
import { Settings } from "lucide-react";
import { useCookieConsent } from "@/hooks/useCookieConsent";

export const CookieSettingsButton = () => {
  const { openSettings } = useCookieConsent();

  return (
    <button
      onClick={openSettings}
      className="text-white/70 hover:text-white transition-colors text-sm flex items-center gap-2"
    >
      <Settings className="h-4 w-4" />
      Cookie Settings
    </button>
  );
};
